/**
 * The cover an HTML card shows, read from the page's own first-screen
 * measure (`html-frame-bridge.ts`). The measure comes from agent-written
 * page code, so every field is checked and bounded here.
 */
import { hexColor, isVividColor } from "@/components/shapes/shared/card-tint";
import type { HtmlCover } from "./html-poster-theme";

/** Bounds the server enforces too (`frame_thumbnail_services`). */
const HEADLINE_CHARS = 160;
const LINE_CHARS = 200;

function boundedText(value: unknown, max: number): string {
  // By code points, so an emoji or CJK pair is never split.
  return typeof value === "string"
    ? Array.from(value.replace(/\s+/g, " ").trim()).slice(0, max).join("")
    : "";
}

/**
 * The cover for a page whose frame reported `measure`, with `placeholder`
 * (the poster's average colour). Every page's poster is its cover, a
 * text-only page's too; one that could not be measured has no text.
 */
export function coverFromMeasure(
  measure: unknown,
  placeholder: string | null,
): HtmlCover {
  const record =
    measure && typeof measure === "object"
      ? (measure as Record<string, unknown>)
      : {};
  const hero = hexColor(record.heroColor);
  return {
    kind: "cover",
    headline: boundedText(record.headline, HEADLINE_CHARS),
    line: boundedText(record.line, LINE_CHARS),
    tint:
      hexColor(record.themeColor) ?? (hero && isVividColor(hero) ? hero : null),
    placeholder,
  };
}
